module.exports = __webpack_public_path__ + "img/shopping-mall.b2148faf.webp";